import React, {useState} from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Heading from "@amzn/meridian/heading";
import Input from "@amzn/meridian/input";
import {IProcessPathCapacity} from "../../common/api/api";
import CreatableSelect from "react-select/creatable";
import {nanoid} from "nanoid";

function PPCapacityAddForm({
                               addFormHandler,
                               uniqueProcessPaths,
                               cancelHandler,
                               uniqueSizes,
                               selectedNode
                           }) {
    const [process_path, setProcess_path] = useState("");
    const [size, setSize] = useState("");
    const [capacity, setCapacity] = useState("");

    function submitHandler(event) {
        event.preventDefault();
        if (!process_path || !size || !capacity) {
            setErrorMessage("Fill all the fields before submitting!");
        } else {
            const addData: IProcessPathCapacity = {
                id: nanoid(),
                process_path: process_path['label'],
                size: size['label'],
                capacity: parseInt(capacity),
            };
            addFormHandler(addData);
        }
    }

    //Convert processPath to hold value and label
    uniqueProcessPaths = uniqueProcessPaths.map((str) => ({
        value: str,
        label: str,
    }));
    //Convert size to hold value and label
    uniqueSizes = uniqueSizes.map((str) => ({
        value: str,
        label: str,
    }));
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            borderBottom: "1px dotted green",
            color: state.isFocused ? "Forest" : "Forest",
            padding: 10,
            "&:hover": {borderColor: "green"}, // border style on hover
            boxShadow: "none", // no box-shadow
        }),
    };
    //Error checking
    const [errorMessage, setErrorMessage] = useState("");
    return (
        <>
            <form onSubmit={submitHandler}>
                <Column>
                    <Heading level={4}>Add New Process Path Capacity</Heading>
                    <div style={{width: "300px", height: "40px"}}>
                        <CreatableSelect
                            isClearable
                            onChange={setProcess_path}
                            options={uniqueProcessPaths}
                            value={process_path}
                            styles={customStyles}
                            placeholder="Process Path"
                        />
                    </div>
                    <div style={{width: "200px", height: "40px"}}>
                        <CreatableSelect
                            isClearable
                            onChange={setSize}
                            options={uniqueSizes}
                            value={size}
                            styles={customStyles}
                            placeholder="Size"
                        />
                    </div>
                    <Input
                        name="capacity"
                        value={capacity}
                        label="Capacity"
                        type="number"
                        onChange={setCapacity}
                        width={100}
                        size="small"
                    />
                    <Box>
                        <Row>
                            <Button submit={true}>Add</Button>
                            <Button onClick={cancelHandler}>Cancel</Button>
                            {errorMessage && <p className="errorMsg"> {errorMessage} </p>}
                        </Row>
                    </Box>
                    <Row></Row>
                </Column>

            </form>
        </>
    );
}

export default PPCapacityAddForm;
